/* @ts-self-types="./hakuban.d.ts" */

export class WasmResult {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WasmResult.prototype);
        obj.__wbg_ptr = ptr;
        WasmResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WasmResultFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wasmresult_free(ptr, 0);
    }
    /**
     * @returns {string | undefined}
     */
    get error_message() {
        const ret = wasm.__wbg_get_wasmresult_error_message(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {number | undefined}
     */
    get pointer() {
        const ret = wasm.__wbg_get_wasmresult_pointer(this.__wbg_ptr);
        return ret === 0x100000001 ? undefined : ret;
    }
    /**
     * @returns {WasmResultStatus}
     */
    get status() {
        const ret = wasm.__wbg_get_wasmresult_status(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {string | null} [arg0]
     */
    set error_message(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_wasmresult_error_message(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {number | null} [arg0]
     */
    set pointer(arg0) {
        wasm.__wbg_set_wasmresult_pointer(this.__wbg_ptr, isLikeNone(arg0) ? 0x100000001 : (arg0) >>> 0);
    }
    /**
     * @param {WasmResultStatus} arg0
     */
    set status(arg0) {
        wasm.__wbg_set_wasmresult_status(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) WasmResult.prototype[Symbol.dispose] = WasmResult.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9}
 */
export const WasmResultStatus = Object.freeze({
    Ok: 0, "0": "Ok",
    Pointer: 1, "1": "Pointer",
    Pending: 2, "2": "Pending",
    EndOfStream: 3, "3": "EndOfStream",
    InvalidString: 4, "4": "InvalidString",
    InvalidJSON: 5, "5": "InvalidJSON",
    InvalidURL: 6, "6": "InvalidURL",
    InvalidLogLevel: 7, "7": "InvalidLogLevel",
    LoggerInitializationError: 8, "8": "LoggerInitializationError",
    ConnectionTerminated: 9, "9": "ConnectionTerminated",
});

/**
 * @param {number} exchange
 */
export function hakuban_exchange_drop(exchange) {
    wasm.hakuban_exchange_drop(exchange);
}

/**
 * @returns {WasmResult}
 */
export function hakuban_exchange_new() {
    const ret = wasm.hakuban_exchange_new();
    return WasmResult.__wrap(ret);
}

/**
 * @param {number} exchange
 * @returns {BigUint64Array}
 */
export function hakuban_exchange_notified(exchange) {
    const ret = wasm.hakuban_exchange_notified(exchange);
    var v1 = getArrayU64FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
    return v1;
}

/**
 * @param {number} future
 */
export function hakuban_future_drop(future) {
    wasm.hakuban_future_drop(future);
}

/**
 * @param {number} exchange_pointer
 * @param {number} future_pointer
 * @param {bigint} waker_id
 * @returns {WasmResult}
 */
export function hakuban_future_poll(exchange_pointer, future_pointer, waker_id) {
    const ret = wasm.hakuban_future_poll(exchange_pointer, future_pointer, waker_id);
    return WasmResult.__wrap(ret);
}

/**
 * @param {string} default_log_level
 * @returns {WasmResult}
 */
export function hakuban_logger_initialize(default_log_level) {
    const ptr0 = passStringToWasm0(default_log_level, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.hakuban_logger_initialize(ptr0, len0);
    return WasmResult.__wrap(ret);
}

/**
 * @param {number} message_pointer
 * @returns {Uint8Array}
 */
export function hakuban_message_serialize(message_pointer) {
    const ret = wasm.hakuban_message_serialize(message_pointer);
    var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v1;
}

/**
 * @param {number} descriptor_pointer
 */
export function hakuban_object_descriptor_drop(descriptor_pointer) {
    wasm.hakuban_object_descriptor_drop(descriptor_pointer);
}

/**
 * @param {number} descriptor_pointer
 * @returns {string}
 */
export function hakuban_object_descriptor_json(descriptor_pointer) {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.hakuban_object_descriptor_json(descriptor_pointer);
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {string} json_string
 * @param {Uint32Array} tag_pointers
 * @returns {WasmResult}
 */
export function hakuban_object_descriptor_new(json_string, tag_pointers) {
    const ptr0 = passStringToWasm0(json_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray32ToWasm0(tag_pointers, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.hakuban_object_descriptor_new(ptr0, len0, ptr1, len1);
    return WasmResult.__wrap(ret);
}

/**
 * @param {number} descriptor_pointer
 * @returns {Uint32Array}
 */
export function hakuban_object_descriptor_tags(descriptor_pointer) {
    const ret = wasm.hakuban_object_descriptor_tags(descriptor_pointer);
    var v1 = getArrayU32FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @param {number} object_ptr
 */
export function hakuban_object_expose_contract_drop(object_ptr) {
    wasm.hakuban_object_expose_contract_drop(object_ptr);
}

/**
 * @param {number} exchange
 * @param {number} descriptor
 * @param {number} capacity
 * @returns {number}
 */
export function hakuban_object_expose_contract_new(exchange, descriptor, capacity) {
    const ret = wasm.hakuban_object_expose_contract_new(exchange, descriptor, capacity);
    return ret >>> 0;
}

/**
 * @param {number} object_expose_pointer
 * @returns {number}
 */
export function hakuban_object_expose_contract_next(object_expose_pointer) {
    const ret = wasm.hakuban_object_expose_contract_next(object_expose_pointer);
    return ret >>> 0;
}

/**
 * @param {number} object_ptr
 */
export function hakuban_object_observe_contract_drop(object_ptr) {
    wasm.hakuban_object_observe_contract_drop(object_ptr);
}

/**
 * @param {number} exchange
 * @param {number} descriptor
 * @returns {number}
 */
export function hakuban_object_observe_contract_new(exchange, descriptor) {
    const ret = wasm.hakuban_object_observe_contract_new(exchange, descriptor);
    return ret >>> 0;
}

/**
 * @param {number} object_observe_pointer
 * @returns {number}
 */
export function hakuban_object_observe_contract_next(object_observe_pointer) {
    const ret = wasm.hakuban_object_observe_contract_next(object_observe_pointer);
    return ret >>> 0;
}

/**
 * @param {number} object_state_pointer
 * @returns {Uint8Array}
 */
export function hakuban_object_state_data(object_state_pointer) {
    const ret = wasm.hakuban_object_state_data(object_state_pointer);
    var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v1;
}

/**
 * @param {number} object_state_pointer
 */
export function hakuban_object_state_drop(object_state_pointer) {
    wasm.hakuban_object_state_drop(object_state_pointer);
}

/**
 * @param {number} object_state_pointer
 * @returns {any[]}
 */
export function hakuban_object_state_format(object_state_pointer) {
    const ret = wasm.hakuban_object_state_format(object_state_pointer);
    var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @param {BigInt64Array} version
 * @param {any[]} format_jsvalues
 * @param {Uint8Array} data
 * @param {bigint} synchronized_us_ago
 * @returns {WasmResult}
 */
export function hakuban_object_state_new(version, format_jsvalues, data, synchronized_us_ago) {
    const ptr0 = passArray64ToWasm0(version, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArrayJsValueToWasm0(format_jsvalues, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ptr2 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
    const len2 = WASM_VECTOR_LEN;
    const ret = wasm.hakuban_object_state_new(ptr0, len0, ptr1, len1, ptr2, len2, synchronized_us_ago);
    return WasmResult.__wrap(ret);
}

/**
 * @param {number} object_state_sink_pointer
 * @returns {number}
 */
export function hakuban_object_state_sink_descriptor(object_state_sink_pointer) {
    const ret = wasm.hakuban_object_state_sink_descriptor(object_state_sink_pointer);
    return ret >>> 0;
}

/**
 * @param {number} object_state_sink_pointer
 */
export function hakuban_object_state_sink_drop(object_state_sink_pointer) {
    wasm.hakuban_object_state_sink_drop(object_state_sink_pointer);
}

/**
 * @param {number} object_state_sink_pointer
 * @returns {number}
 */
export function hakuban_object_state_sink_next(object_state_sink_pointer) {
    const ret = wasm.hakuban_object_state_sink_next(object_state_sink_pointer);
    return ret >>> 0;
}

/**
 * @param {number} object_state_sink_params_pointer
 */
export function hakuban_object_state_sink_params_drop(object_state_sink_params_pointer) {
    wasm.hakuban_object_state_sink_params_drop(object_state_sink_params_pointer);
}

/**
 * @param {number} object_state_sink_pointer
 * @param {number} object_state_pointer
 * @returns {number}
 */
export function hakuban_object_state_sink_push(object_state_sink_pointer, object_state_pointer) {
    const ret = wasm.hakuban_object_state_sink_push(object_state_sink_pointer, object_state_pointer);
    return ret >>> 0;
}

/**
 * @param {number} object_state_stream_pointer
 * @returns {number}
 */
export function hakuban_object_state_stream_descriptor(object_state_stream_pointer) {
    const ret = wasm.hakuban_object_state_stream_descriptor(object_state_stream_pointer);
    return ret >>> 0;
}

/**
 * @param {number} object_state_stream_pointer
 */
export function hakuban_object_state_stream_drop(object_state_stream_pointer) {
    wasm.hakuban_object_state_stream_drop(object_state_stream_pointer);
}

/**
 * @param {number} object_state_stream_pointer
 * @returns {number}
 */
export function hakuban_object_state_stream_next(object_state_stream_pointer) {
    const ret = wasm.hakuban_object_state_stream_next(object_state_stream_pointer);
    return ret >>> 0;
}

/**
 * @param {number} object_state_pointer
 * @returns {bigint}
 */
export function hakuban_object_state_synchronized_ago(object_state_pointer) {
    const ret = wasm.hakuban_object_state_synchronized_ago(object_state_pointer);
    return BigInt.asUintN(64, ret);
}

/**
 * @param {number} object_state_pointer
 * @returns {BigInt64Array}
 */
export function hakuban_object_state_version(object_state_pointer) {
    const ret = wasm.hakuban_object_state_version(object_state_pointer);
    var v1 = getArrayI64FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 8, 8);
    return v1;
}

/**
 * @param {number} descriptor_pointer
 */
export function hakuban_tag_descriptor_drop(descriptor_pointer) {
    wasm.hakuban_tag_descriptor_drop(descriptor_pointer);
}

/**
 * @param {number} descriptor_pointer
 * @returns {string}
 */
export function hakuban_tag_descriptor_json(descriptor_pointer) {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.hakuban_tag_descriptor_json(descriptor_pointer);
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * @param {string} json_string
 * @returns {WasmResult}
 */
export function hakuban_tag_descriptor_new(json_string) {
    const ptr0 = passStringToWasm0(json_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.hakuban_tag_descriptor_new(ptr0, len0);
    return WasmResult.__wrap(ret);
}

/**
 * @param {number} tag_expose_contract_pointer
 */
export function hakuban_tag_expose_contract_drop(tag_expose_contract_pointer) {
    wasm.hakuban_tag_expose_contract_drop(tag_expose_contract_pointer);
}

/**
 * @param {number} exchange
 * @param {number} descriptor
 * @param {number} capacity
 * @returns {number}
 */
export function hakuban_tag_expose_contract_new(exchange, descriptor, capacity) {
    const ret = wasm.hakuban_tag_expose_contract_new(exchange, descriptor, capacity);
    return ret >>> 0;
}

/**
 * @param {number} tag_expose_pointer
 * @returns {number}
 */
export function hakuban_tag_expose_contract_next(tag_expose_pointer) {
    const ret = wasm.hakuban_tag_expose_contract_next(tag_expose_pointer);
    return ret >>> 0;
}

/**
 * @param {number} tag_pointer
 */
export function hakuban_tag_observe_contract_drop(tag_pointer) {
    wasm.hakuban_tag_observe_contract_drop(tag_pointer);
}

/**
 * @param {number} exchange
 * @param {number} descriptor
 * @returns {number}
 */
export function hakuban_tag_observe_contract_new(exchange, descriptor) {
    const ret = wasm.hakuban_tag_observe_contract_new(exchange, descriptor);
    return ret >>> 0;
}

/**
 * @param {number} tag_observe_pointer
 * @returns {number}
 */
export function hakuban_tag_observe_contract_next(tag_observe_pointer) {
    const ret = wasm.hakuban_tag_observe_contract_next(tag_observe_pointer);
    return ret >>> 0;
}

/**
 * @param {number} wasm_upstream_connection
 */
export function hakuban_upstream_connection_drop(wasm_upstream_connection) {
    wasm.hakuban_upstream_connection_drop(wasm_upstream_connection);
}

/**
 * @param {number} exchange_pointer
 * @param {string} local_name
 * @param {string} local_address
 * @returns {number}
 */
export function hakuban_upstream_connection_new(exchange_pointer, local_name, local_address) {
    const ptr0 = passStringToWasm0(local_name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(local_address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.hakuban_upstream_connection_new(exchange_pointer, ptr0, len0, ptr1, len1);
    return ret >>> 0;
}

/**
 * @param {number} wasm_upstream_connection
 * @returns {number}
 */
export function hakuban_upstream_connection_next_message_to_network(wasm_upstream_connection) {
    const ret = wasm.hakuban_upstream_connection_next_message_to_network(wasm_upstream_connection);
    return ret >>> 0;
}

/**
 * @param {number} wasm_upstream_connection
 * @param {Uint8Array} message_data
 * @returns {number}
 */
export function hakuban_upstream_connection_send_message_from_network(wasm_upstream_connection, message_data) {
    const ptr0 = passArray8ToWasm0(message_data, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.hakuban_upstream_connection_send_message_from_network(wasm_upstream_connection, ptr0, len0);
    return ret >>> 0;
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg___wbindgen_is_undefined_29a43b4d42920abd: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_string_get_7ed5322991caaec5: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'string' ? obj : undefined;
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_throw_6b64449b9b9ed33c: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg_debug_c014a160490283dc: function(arg0) {
            console.debug(arg0);
        },
        __wbg_error_2001591ad2463697: function(arg0) {
            console.error(arg0);
        },
        __wbg_error_a6fa202b58aa1cd3: function(arg0, arg1) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.error(getStringFromWasm0(arg0, arg1));
            } finally {
                wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_info_7479429238bffbce: function(arg0) {
            console.info(arg0);
        },
        __wbg_log_7e1aa9064a1dbdbd: function(arg0) {
            console.log(arg0);
        },
        __wbg_new_227d7c05414eb861: function() {
            const ret = new Error();
            return ret;
        },
        __wbg_now_e7c6795a7f81e10f: function(arg0) {
            const ret = arg0.now();
            return ret;
        },
        __wbg_performance_3fcf6e32a7e1ed0a: function(arg0) {
            const ret = arg0.performance;
            return ret;
        },
        __wbg_stack_3b0d974bbf31e44f: function(arg0, arg1) {
            const ret = arg1.stack;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_static_accessor_GLOBAL_8cfadc87a297ca02: function() {
            const ret = typeof global === 'undefined' ? null : global;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_GLOBAL_THIS_602256ae5c8f42cf: function() {
            const ret = typeof globalThis === 'undefined' ? null : globalThis;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_SELF_e445c1c7484aecc3: function() {
            const ret = typeof self === 'undefined' ? null : self;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_WINDOW_f20e8576ef1e0f17: function() {
            const ret = typeof window === 'undefined' ? null : window;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_warn_3cc416af27dbdc02: function(arg0) {
            console.warn(arg0);
        },
        __wbindgen_cast_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./hakuban_bg.js": import0,
    };
}

const WasmResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_wasmresult_free(ptr >>> 0, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function getArrayI64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getBigInt64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_externrefs.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}

function getArrayU32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayU64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getBigUint64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedBigInt64ArrayMemory0 = null;
function getBigInt64ArrayMemory0() {
    if (cachedBigInt64ArrayMemory0 === null || cachedBigInt64ArrayMemory0.byteLength === 0) {
        cachedBigInt64ArrayMemory0 = new BigInt64Array(wasm.memory.buffer);
    }
    return cachedBigInt64ArrayMemory0;
}

let cachedBigUint64ArrayMemory0 = null;
function getBigUint64ArrayMemory0() {
    if (cachedBigUint64ArrayMemory0 === null || cachedBigUint64ArrayMemory0.byteLength === 0) {
        cachedBigUint64ArrayMemory0 = new BigUint64Array(wasm.memory.buffer);
    }
    return cachedBigUint64ArrayMemory0;
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint32ArrayMemory0 = null;
function getUint32ArrayMemory0() {
    if (cachedUint32ArrayMemory0 === null || cachedUint32ArrayMemory0.byteLength === 0) {
        cachedUint32ArrayMemory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32ArrayMemory0;
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArray32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getUint32ArrayMemory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArray64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8, 8) >>> 0;
    getBigUint64ArrayMemory0().set(arg, ptr / 8);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for (let i = 0; i < array.length; i++) {
        const add = addToExternrefTable0(array[i]);
        getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasm;
function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    wasmModule = module;
    cachedBigInt64ArrayMemory0 = null;
    cachedBigUint64ArrayMemory0 = null;
    cachedDataViewMemory0 = null;
    cachedUint32ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('hakuban_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
